import { render } from "./CategoryPosts.vue?vue&type=template&id=6773b134&scoped=true"
import script from "./CategoryPosts.vue?vue&type=script&lang=js"
export * from "./CategoryPosts.vue?vue&type=script&lang=js"

import "./CategoryPosts.vue?vue&type=style&index=0&id=6773b134&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Nebula PC\\Coding\\web-projects\\snowchron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6773b134"]])

export default __exports__